import React, { useEffect, useState, useContext, useRef } from "react";
import dayjs from "dayjs";
import { TableHeader } from "../../../components/table/TableHeader";
import { appServerSideProps } from "../../../utils/getAppService";
import { authGetRequest } from "../../../utils/authGetRequest";
import { AiOutlineSearch, AiOutlineCloseCircle } from "react-icons/ai";
import ScrollableTable from "../../../components/table/ScrollableTable";
import Input from "../../../components/form/Input";
import Calendar from "../../../components/calendar/Calendar";
import Utils from "../../../utils/Utils";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import TableSkeleton from "../../../components/table/TableSkeleton";
import Link from "next/link";
import { AppContext } from "../../../context/state";
import transformTime from "../linevalue-welcome/utils/transformTime";
import Head from "next/head";
import MainLayout from "../../../components/MainLayout/MainLayout";
import { useRouter } from "next/router";
import { SQHeaderLockContent } from "../../../components/SQPremiumLock/SQPremiumLock";
import advancedFormat from "dayjs/plugin/advancedFormat";
import LineValueStats from "../../../components/linevalue/linevalue-stats";
import WinningMetrics from "../../../components/WinningMetrics";
import { getDefYear } from "../../../constants/main";

dayjs.extend(advancedFormat);
let ascOrder = true;

const pendingPlaysHeader = [
  {
    title: "Date",
    showImage: false,
    sortable: false,
    key: "Date",
    classList: ["shrink-column"],
  },
  {
    title: "Time (ET)",
    showImage: false,
    sortable: false,
    key: "Time",
    classList: ["shrink-column"],
  },
  {
    title: "Home Team",
    showImage: false,
    sortable: false,
    key: "Home",
    classList: ["shrink-column"],
  },
  {
    title: "Away Team",
    showImage: false,
    sortable: false,
    key: "Away",
    classList: ["shrink-column"],
  },
  {
    title: "Home Projected Score",
    showImage: false,
    sortable: false,
    key: "Projected Home Score",
    classList: ["shrink-column"],
  },
  {
    title: "Away Projected Score",
    showImage: false,
    sortable: false,
    key: "Projected Away Score",
    classList: ["shrink-column"],
  },
  {
    title: "Total Projected Score",
    showImage: false,
    sortable: false,
    key: "Total Projected Score",
    classList: ["shrink-column"],
  },
  {
    title: "Side With Value",
    showImage: false,
    sortable: false,
    key: "Side with Value",
    classList: ["shrink-column"],
  },
  {
    title: "Line at Time of Play",
    showImage: false,
    sortable: false,
    key: "Consensus Opener",
    classList: ["shrink-column"],
  },
  {
    title: "Play Line Value",
    showImage: false,
    sortable: false,
    key: "Play Line Value",
    classList: ["shrink-column"],
  },
  // {
  //   title: "Play",
  //   showImage: false,
  //   sortable: false,
  //   key: "play",
  //   classList: ["shrink-column"],
  // },
];
const ModelResults = ({ user }) => {
  const router = useRouter();
  let leagueFromUrl = router.query?.league;
  const { store, setStore } = useContext(AppContext);
  const [tableLoaded, setTableLoaded] = useState(false);
  const searchInputRef = useRef(null);
  const [displaySearchResults, setDisplaySearchResults] = useState(false);
  const [searchAutocomplete, setSearchAutocomplete] = useState({
    team: [],
    conference: [],
  });
  const yesterdayDate = new Date(new Date().setDate(new Date().getDate() - 1));
  const [authToken, setAuthToken] = useState(null);
  useEffect(() => {
    setAuthToken(document.cookie.split("token_access=").pop().split(";").shift());
  }, []);
  const [searchKey, setSearchKey] = useState("");
  const [teamData, setTeamData] = useState([]);
  const [filteredTeamData, setFilteredTeamData] = useState([]);

  const [pendingPlays, setPendingPlays] = useState([]);
  const [filteredPendingPlays, setFilteredPendingPlays] = useState([]);
  const [isSpread, setIsSpread] = useState(false);
  const [sortedKey, setSortedKey] = useState("");

  // default date always should be yesterday
  const [activeDate, setActiveDate] = useState(new Date(new Date().setDate(new Date().getDate() - 1)));
  const [domLoaded, setDomLoaded] = useState(false);
  let leagueYear = getDefYear(leagueFromUrl);
  useEffect(() => {
    setDomLoaded(true);
  }, []);

  const formatedEstTime = dayjs("9 Feb 2023 1:00:00 EST").format("LT");
  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlanV2(user);
  const isPaidPlan = (isStandardPlan || isPremiumPlan) && user.has_paid;
  const hideResultsCard = !isPaidPlan && (store.leagueType === "wnba" || store.leagueType === "nba");
  let miscTableHeader = [
    {
      title: "Time (ET)",
      showImage: false,
      sortable: true,
      key: "Time",
      classList: [""],
    },
    {
      title: "Home Team",
      showImage: false,
      sortable: true,
      key: "Home",
    },
    {
      title: "Away Team",
      showImage: false,
      sortable: true,
      key: "Away",
      classList: [""],
    },
    {
      title: "Projected Score",
      showImage: false,
      sortable: true,
      key: "Projected (Home)",
      // offen: "hmarg",
      // defen: "tot",
      classList: [""],
    },
    {
      title: "Projected",
      showImage: false,
      sortable: true,
      key: "Projected (Home)",
      classList: [],
    },
    {
      title: "Opening Line",
      showImage: false,
      sortable: true,
      key: "line",
      offen: "concen",
      defen: "concentot",
    },
    {
      title: "Closing Line",
      showImage: false,
      sortable: true,
      key: "line",
      offen: "concen",
      defen: "concentot",
    },
    {
      title: "Closing Line Value",
      showImage: false,
      sortable: false,
      key: "line_value",
    },
    {
      title: "Side with Line Value",
      showImage: false,
      sortable: true,
      key: "value_side",
      offen: "concen",
      defen: "concentot",
      // classList: [isSpread ? "" : "d-none"],
    },
    {
      title: "Points of Value",
      showImage: false,
      sortable: true,
      key: "valuee",
      // offen: 'concen',
      // defen: 'concentot',
      // classList: [isSpread ? '' : 'd-none']
    },
    {
      title: "Final Score",
      showImage: false,
      sortable: true,
      key: "Final Score",
      offen: "teamval",
      defen: "totside",
    },
    {
      title: "SQ Score",
      showImage: false,
      sortable: true,
      key: "SQ Score",
      offen: "finalval",
      defen: "totalval",
    },
    {
      title: "Play",
      showImage: false,
      sortable: true,
      key: "line",
    },
  ];
  if (!isPremiumPlan) {
    // remove sq score if not standard user
    miscTableHeader = miscTableHeader.filter((column) => column["key"] !== "SQ Score");
  }
  if (leagueFromUrl === "nba") {
    miscTableHeader = miscTableHeader.filter(
      (column) =>
        column["title"] !== "Projected Score" &&
        column["title"] !== "Projected" &&
        column["title"] !== "Points of Value" &&
        column["title"] !== "Play"
    );
  }

  const tableRef = useRef();
  const pendingPlaysTableRef = useRef();

  useEffect(() => {
    if (domLoaded && user) {
      authGetRequest(`/api/${leagueFromUrl ? leagueFromUrl : store.leagueType}/value-finder/pending-plays`, authToken)
        .then((response) => response.data)
        .then((response) => {
          setPendingPlays(response.data);
        })
        .catch(async (err) => {
          if (err.message.includes("401")) {
            try {
              const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/refresh`, {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
                body: authToken,
              })
                .then((res) => res.json())
                .then((response) => {
                  if (response.access_token) {
                    setCookie("token_access", response.access_token);
                    setAuthToken(response.access_token);
                    router.reload();
                  }
                });
            } catch (error) {
              console.error(error);
            }
          }
          console.error(err);
        });
    }

    if ((domLoaded && !user) || (!user?.has_paid && !Utils.hasTrial(user))) {
      fetch(
        `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${
          leagueFromUrl ? leagueFromUrl : store.leagueType
        }/value-finder/pending-plays/unprotected`
      )
        .then((response) => response.json())
        .then((response) => {
          setPendingPlays(response.data);
          // setTableLoaded(true);
        })
        .catch(async (err) => {
          console.error(err);
        });
    }
  }, [authToken, user]);
  useEffect(() => {
    if (pendingPlays.length > 0) {
      setFilteredPendingPlays(pendingPlays);
    }
  }, [pendingPlays]);

  useEffect(() => {
    if (leagueFromUrl) {
      let league = leagueFromUrl;
      setStore({ ...store, leagueType: league });
    }
    setFilteredTeamData([...filterDataByCategory()]);
    setFilteredPendingPlays([...filterPendingPlaysByCategory()]);
  }, [leagueFromUrl]);

  useEffect(() => {
    if (filteredTeamData.length === 0 || filteredTeamData.length === undefined) {
      router.push(`/${leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl}/model-results?games=none`, undefined, {
        shallow: true,
      });
    } else {
      router.push(`/${leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl}/model-results`, undefined, {
        shallow: true,
      });
    }
  }, [filteredTeamData]);

  function downloadCSV(data, type = "csv") {
    const link = document.createElement("a");
    var binaryData = [];
    binaryData.push(data);
    const url = window.URL.createObjectURL(new Blob(binaryData, { type: `application/${type}` }));
    link.href = url;
    link.download = `model-results-${dayjs().format("MM-DD-YYYY")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function exportResults() {
    if (isStandardPlan) {
      alert("You need to upgrade to Premium to export results");
      return;
    }
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/export/${store.leagueType}/csv/value-finder/results_page`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }).then((response) => {
      response.blob().then((blob) => {
        downloadCSV(blob, "csv");
      });
    });
  }

  const sort = (key) => {
    let res = [];

    let rawData = filterDataByCategory();

    let replaceKey;
    const headerObj = miscTableHeader.filter((column) => column["key"] === key)[0];

    replaceKey = headerObj["key"];

    if (key === "play") {
      replaceKey = "finalval";
    }

    if (key === "concen") {
      replaceKey = "concentot";
    }

    if (key === "finalval") {
      replaceKey = "totalval";
    }
    let keySumm = {};

    if (key === "Projected (Home)") {
      replaceKey = "summaryColumns";
      keySumm["key1"] = "projected_home_score";
      keySumm["key2"] = "projected_away_score";
    }

    if (key === "Final Score") {
      replaceKey = "Final Score";
      keySumm["key1"] = "home_pts";
      keySumm["key2"] = "away_pts";
    }

    if (key === "SQ Score") {
      replaceKey = "SQ Score";
      keySumm["key1"] = "home_sq_pts";
      keySumm["key2"] = "away_sq_pts";
    }

    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";

      res = rawData.sort(Utils.dynamicsort(replaceKey, order, keySumm));
      ascOrder = order === "desc";
    } else {
      ascOrder = false;
      setSortedKey(key);
      res = rawData.sort(Utils.dynamicsort(replaceKey, null, keySumm));
    }
    setFilteredTeamData([...res]);
  };
  const filterDataByCategory = () => {
    let rawData = searchKey.length > 0 ? filteredTeamData : teamData;

    rawData = rawData.filter((game) => {
      if (!game.is_spread) {
        return true;
      } else {
        return false;
      }
    });
    return rawData;
  };
  const filterPendingPlaysByCategory = () => {
    let rawData = pendingPlays;

    rawData = rawData.filter((game) => {
      if (game.is_spread) {
        return true;
      } else {
        return false;
      }
    });
    return rawData;
  };
  if (leagueFromUrl === "ncaa") {
    leagueFromUrl = "college_mens";
  }

  useEffect(() => {
    const fetchData = async () => {
      const data = [];
      const promises = [];
      for (let index = 0; index < 7; index++) {
        const pastDate = dayjs().subtract(index, "days");
        const promise = fetch(
          `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${
            leagueFromUrl ? leagueFromUrl : store.leagueType
          }/results-page/${pastDate.format("YYYY-MM-DD")}`
        )
          .then((response) => response.json())
          .then((response) => {
            const transformedData = response.data.map((game) => {
              return {
                ...game,
                game_link: `${game.date}%20${game.home_team}%20${game.away_team}`,
              };
            });
            data.push(...transformedData);
          })
          .catch(async (err) => {
            console.error(err);
          });
        promises.push(promise);
      }
      await Promise.all(promises);
      setTeamData(data);
      setTableLoaded(true);
    };
    // fetchData();
    const today = dayjs().format("YYYY-MM-DD");
    const pastDate = dayjs()
      .subtract(isPremiumPlan ? 30 : 7, "days")
      .format("YYYY-MM-DD");

    fetch(
      `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${
        leagueFromUrl ? leagueFromUrl : store.leagueType
      }/results-page/${today}/${pastDate}`
    )
      .then((response) => response.json())
      .then((response) => {
        const transformedData = response.data
          .map((game) => {
            return {
              ...game,
              game_link: `${game.date}%20${game.home_team}%20${game.away_team}`,
            };
          })
          .sort((a, b) => b.date.localeCompare(a.date));
        setTeamData(transformedData);
      })
      .catch(async (err) => {
        console.error(err);
      })
      .finally(() => {
        setTableLoaded(true);
      });
  }, [store]);

  useEffect(() => {
    setFilteredTeamData(teamData);
  }, [teamData]);

  const searchByTeam = (searchTerm) => {
    return Array.from(
      new Set(
        teamData
          .filter(
            (game) =>
              game.home_team?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              game.away_team?.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((game) => game.home_team + " vs " + game.away_team)
      )
    );
  };

  const searchByConference = (searchTerm) => {
    return Array.from(
      new Set(
        teamData
          .filter(
            (game) =>
              game.home_conference?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              game.away_conference?.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((game) => game.home_conference || game.away_conference)
      )
    );
  };

  const handleInputChange = (e) => {
    if (e.target.value.length > 0) {
      setSearchKey(e.target.value);
      setDisplaySearchResults(true);
    }
  };

  const searchData = (searchTerm, searchType) => {
    let newRecords;

    if (searchType === "team") {
      newRecords = teamData.filter((r) => r.home_team === searchTerm || r.away_team === searchTerm);
    } else {
      newRecords = teamData.filter((r) => r.home_conference === searchTerm || r.away_conference === searchTerm);
    }

    return newRecords;
  };

  const displaySearchData = (e, searchType) => {
    searchInputRef.current.value = e.target.innerText.split(" vs ")[0];
    setSearchKey(e.target.innerText.split(" vs ")[0]);
    setFilteredTeamData([...searchData(e.target.innerText.split(" vs ")[0], searchType)]);
    setDisplaySearchResults(false);
  };

  const clearSearch = (e) => {
    setSearchKey("");
    setFilteredTeamData(teamData);
    searchInputRef.current.value = "";
    setDisplaySearchResults(false);
  };

  useEffect(() => {
    setSearchAutocomplete({
      team: searchByTeam(searchKey).splice(0, 7),
      conference: searchByConference(searchKey).splice(0, 5),
    });
  }, [searchKey, setSearchKey]);

  const SQPremiumLockHeader = () => {
    return (
      <>
        <TableHeader headers={SQHeaderLockContent} />
        78.9
      </>
    );
  };
  const lockCssStyle = !isPaidPlan
    ? { textAlign: "center", color: "transparent", textShadow: "0 0 7px #000", position: "relative" }
    : { textAlign: "center", verticalAlign: "middle" };

  return (
    <>
      <Head>
        <title>ShotQuality Bets | Model Results</title>
      </Head>
      <MainLayout>
        <main id="ContentBox" style={{ minHeight: "100vh" }}>
          <div className="MiscStats Value-Finder">
            <section className="header-primary">
              <div className="container-fluid">
                {tableLoaded && (
                  <div className="row" style={{ justifyContent: "space-between" }}>
                    <div className="box col-md-3">
                      {/* <h2>Model Results</h2> */}
                      <div className="d-flex">
                        <div style={{ display: "flex", flexDirection: "column", marginLeft: "30px" }}>
                          {store.leagueType === "nba" && (
                            <h2 style={{ fontSize: "30px", marginLeft: 0 }}>NBA Model Results</h2>
                          )}

                          {store.leagueType === "college_mens" && (
                            <h2 style={{ fontSize: "30px", marginLeft: 0 }}>NCAA Model Results</h2>
                          )}
                          {store.leagueType === "wnba" && (
                            <h2 style={{ fontSize: "30px", marginLeft: 0 }}>WNBA Model Results</h2>
                          )}

                          <p style={{ marginBottom: 0 }}>Play to win with ShotQualityBets predictive analytics. </p>
                        </div>
                      </div>
                    </div>
                    {leagueFromUrl !== "nba" && leagueFromUrl !== "college_mens" && (
                      <div className="box col-md-9">
                        <LineValueStats league={leagueFromUrl} />
                      </div>
                    )}
                  </div>
                )}

                {!tableLoaded && (
                  <div className="row align-items-center">
                    <div className="box col-sm-12 col-md-8 d-sm-flex text-center">
                      <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
                        <Skeleton height="39px" width="300px" />
                      </SkeletonTheme>
                    </div>
                    <div className="box col-sm-12 col-md-4">
                      <SkeletonTheme color="#a4abb3" highlightColor="#e3e6e8">
                        <Skeleton height="39px" width="100%" style={{ borderRadius: "30px" }} />
                      </SkeletonTheme>
                    </div>
                  </div>
                )}
                {/* </Container> */}
              </div>
            </section>

            <section className="page-content">
              <div className="container-fluid">
                <div
                  className="row justify-content-center"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* <div className="row"> */}
                  <div className="col-md-12 row">
                    <div className="col-md-3">
                      <div
                        style={{
                          background: "#0F131B",
                          borderRadius: "10px",
                          width: "380px",
                        }}
                        className="btn-group model-results-buttons"
                      >
                        <button
                          type="button"
                          className={`btn btn-lg btn-primary value-finder-buttons-group ${!isSpread ? "active" : ""}`}
                          onClick={() => setIsSpread(false)}
                        >
                          Projected Total
                        </button>
                        <button
                          type="button"
                          className={`btn btn-lg btn-primary value-finder-buttons-group ${isSpread ? "active" : ""}`}
                          onClick={() => setIsSpread(true)}
                        >
                          Projected Spread
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        fontSize: 24,
                        fontWeight: 700,
                        // marginTop: 50,
                        textAlign: "center",
                        color: "black",
                      }}
                      className="col-md-4"
                    ></div>
                    <div className="position-relative flex-row ml-auto my-2 my-md-0">
                      {leagueFromUrl !== "nba" && (
                        <div className="">
                          {/* <Link
                            href={
                              hideResultsCard
                                ? `/login`
                                : `/${leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl}/betting-results`
                            }
                          >
                            <button className="btn btn-secondary" style={{ padding: "12px 16px" }}>
                              Betting Results
                            </button>
                          </Link> */}
                          {isPremiumPlan && (
                            <button className="btn export-button ml-md-2  mt-2 mt-md-0" onClick={exportResults}>
                              Download Graded Plays
                            </button>
                          )}
                        </div>
                      )}
                      {/* <div className="box col-md-7 ml-auto">
                        <Input
                          icon={<AiOutlineSearch />}
                          placeholder="Search Team/Conference"
                          className="form-control w-100 search-input model-results-search"
                          ref={searchInputRef}
                          onInput={handleInputChange}
                          rightIcon={
                            searchInputRef?.current?.value.length > 0 ? (
                              <AiOutlineCloseCircle onClick={clearSearch} />
                            ) : null
                          }
                        />
                        {displaySearchResults && (
                          <div className="search-results">
                            <h6 className="text-left-2">Teams</h6>
                            {searchAutocomplete["team"].length > 0 ? (
                              searchAutocomplete["team"].map((searchTerm, i) => (
                                <span
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "team")}
                                  key={`searchTeam${i + 1}`}
                                >
                                  {searchTerm}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}

                            <h6 className="text-left-2">Conferences</h6>
                            {searchAutocomplete["conference"].length > 0 ? (
                              searchAutocomplete["conference"].map((searchTerm, i) => (
                                <span
                                  className="search-results__text"
                                  onClick={(e) => displaySearchData(e, "conference")}
                                  key={`searchConf${i + 1}`}
                                >
                                  {searchTerm}
                                </span>
                              ))
                            ) : (
                              <span disabled={true} className="text-center">
                                No Results Found
                              </span>
                            )}
                          </div>
                        )}
                      </div> */}
                    </div>
                  </div>
                  {/* </div> */}

                  {/* <div className="col-md-12">
                    <Calendar
                      {...{
                        date: activeDate,
                        setDate: setActiveDate,
                      }}
                    />
                  </div> */}
                </div>
                {domLoaded && (
                  <>
                    {leagueFromUrl !== "nba" && (
                      <>
                        <h4>Pending Plays</h4>
                        <ScrollableTable top="0px" ref={pendingPlaysTableRef}>
                          <div className="table-responsive table-space">
                            <table className="table tl-fixed-desktop" style={{ position: "relative" }}>
                              <thead className="sticky-th-2">
                                <tr className="text-center header-container-table">
                                  <TableHeader
                                    headers={pendingPlaysHeader}
                                    onSortClick={sort}
                                    ascOrder={ascOrder}
                                    sortedKey={sortedKey}
                                  />
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  <>
                                    {filteredPendingPlays.map((team, index) => {
                                      if ((isSpread && team.is_spread) || (!isSpread && !team.is_spread)) {
                                        return (
                                          <tr
                                            key={`${team["Date"]}_${team["Time"]}_${team["Home"]}_${team["Away"]}_${index}`}
                                          >
                                            <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              {dayjs(team.Date).format("MMM. Do")}
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              {team["Time"].length > 10
                                                ? transformTime(team["Time"], true)
                                                : transformTime(team["Time"], false)}
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              <Link
                                                href={`/team/${
                                                  leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                                }/${leagueYear}/${team["Home"]}`}
                                                style={{ color: "#212529" }}
                                                target={"_blank"}
                                              >
                                                {team.Home}
                                              </Link>
                                            </td>
                                            <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              <Link
                                                href={`/team/${
                                                  leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                                }/${leagueYear}/${team["Away"]}`}
                                                style={{ color: "#212529" }}
                                                target={"_blank"}
                                              >
                                                {team.Away}
                                              </Link>
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? <SQPremiumLockHeader /> : team["Projected Home Score"]}
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? <SQPremiumLockHeader /> : team["Projected Away Score"]}
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? (
                                                <SQPremiumLockHeader />
                                              ) : (
                                                Math.round(
                                                  (team["Projected Home Score"] + team["Projected Away Score"]) * 10
                                                ) / 10
                                              )}
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? <SQPremiumLockHeader /> : team["Side with Value"]}
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? <SQPremiumLockHeader /> : team["Consensus Opener"]}
                                            </td>
                                            <td style={lockCssStyle}>
                                              {!isPaidPlan ? <SQPremiumLockHeader /> : Math.abs(team["Consensus"])}
                                            </td>
                                            {/* <td
                                              style={{
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                            >
                                              {team["Play"] ? "Play" : "-"}
                                            </td> */}
                                          </tr>
                                        );
                                      }
                                    })}
                                  </>
                                }
                              </tbody>
                            </table>
                            {/* {tableLoaded &&
                              filteredPendingPlays?.length === 0 &&
                              (leagueFromUrl === "nba" || store.leagueType === "nba") && (
                                <div style={{ width: "100%", display: "flex", "justify-content": "center" }}>
                                  <h4>
                                    {" "}
                                    🧠 The ShotQuality{" "}
                                    {store.leagueType.toLowerCase() === "college_mens"
                                      ? "NCAA"
                                      : store.leagueType.toUpperCase()}{" "}
                                    Model is Learning.{" "}
                                    {store.leagueType.toLowerCase() === "college_mens"
                                      ? "NCAA"
                                      : store.leagueType.toUpperCase()}{" "}
                                    Plays will be available in 2-4 weeks
                                  </h4>
                                </div>
                              )} */}
                            {tableLoaded && filteredPendingPlays?.length === 0 && (
                              <div style={{ width: "100%", display: "flex", "justify-content": "center" }}>
                                <h3 style={{ margin: "0 auto" }}>
                                  There are no upcoming{" "}
                                  {leagueFromUrl.toLowerCase() === "nba"
                                    ? "NBA"
                                    : leagueFromUrl.toLowerCase() === "wnba"
                                    ? "WNBA"
                                    : "College Mens"}{" "}
                                  Plays available.{" "}
                                </h3>
                              </div>
                            )}
                          </div>
                        </ScrollableTable>
                      </>
                    )}

                    <ScrollableTable top="100px" ref={tableRef}>
                      <h3 className="mt-4 mb-3">Graded Plays</h3>
                      <div className="table-responsive table-space">
                        <table className="table tl-fixed-desktop position-relative">
                          <thead className="sticky-th-2">
                            <tr className="text-center header-container-table">
                              <TableHeader
                                headers={miscTableHeader}
                                onSortClick={sort}
                                ascOrder={ascOrder}
                                sortedKey={sortedKey}
                              />
                            </tr>
                          </thead>
                          <tbody>
                            {filteredTeamData.map((game, index) => {
                              if ((isSpread && game.type === "spread") || (!isSpread && game.type === "total")) {
                                return (
                                  <tr key={`${game.date}_${game.home_team}_${game.away_team}_${index}`}>
                                    {/* time */}
                                    <td
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {game.date}
                                      <br />

                                      {isPaidPlan && (
                                        <Link
                                          href={`/live?gid=${game.game_id}`}
                                          style={{ color: "#212529" }}
                                          target={"_blank"}
                                        >
                                          📺 ScoreCenter
                                        </Link>
                                      )}
                                    </td>
                                    {/* home team */}
                                    <td style={{ verticalAlign: "middle" }}>
                                      <Link
                                        href={`/team/${
                                          leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                        }/${leagueYear}/${game.home_team}`}
                                        style={{ color: "#212529" }}
                                        target={"_blank"}
                                      >
                                        <img
                                          src={`http://shotqualitybets.com/static/media/logos/${game.home_team}.png`}
                                          alt={""}
                                          className="img-fluid w-25 pull-left GameCard__team--logo logo-left2"
                                        />
                                        &nbsp; {game.home_team}
                                      </Link>
                                    </td>
                                    {/* away team */}
                                    <td style={{ verticalAlign: "middle" }}>
                                      <Link
                                        href={`/team/${
                                          leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                        }/${leagueYear}/${game.away_team}`}
                                        style={{ color: "#212529" }}
                                        target={"_blank"}
                                      >
                                        <img
                                          src={`http://shotqualitybets.com/static/media/logos/${game.away_team}.png`}
                                          alt={""}
                                          className="img-fluid w-25 pull-left GameCard__team--logo logo-left2"
                                        />
                                        &nbsp; {game.away_team}
                                      </Link>
                                    </td>
                                    {/* projected home score */}
                                    {leagueFromUrl !== "nba" && (
                                      <td
                                        className={isPaidPlan ? "" : "data-blur"}
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {!isPaidPlan ? (
                                          <SQPremiumLockHeader />
                                        ) : (
                                          <Link
                                            href={`/game/${
                                              leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                            }/2023/${game?.home_team}/${game?.game_link}`}
                                            style={{ color: "#212529" }}
                                            target={"_blank"}
                                          >
                                            {Math.round(game.projected_home_score)} -{" "}
                                            {Math.round(game.projected_away_score)}
                                          </Link>
                                        )}
                                      </td>
                                    )}
                                    {/* projected away score */}
                                    {leagueFromUrl !== "nba" && (
                                      <td
                                        className={isPaidPlan ? "" : "data-blur"}
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {!isPaidPlan ? (
                                          <SQPremiumLockHeader />
                                        ) : isSpread ? (
                                          parseFloat(
                                            String(game.projected_away_score - game.projected_home_score)
                                          ).toFixed(1)
                                        ) : (
                                          parseFloat(
                                            String(game.projected_away_score + game.projected_home_score)
                                          ).toFixed(1)
                                        )}
                                      </td>
                                    )}
                                    {/* opening line */}
                                    <td
                                      className={isPaidPlan ? "" : "data-blur"}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {!isPaidPlan ? <SQPremiumLockHeader /> : game.line}
                                    </td>
                                    {/*  closing line */}
                                    <td
                                      className={isPaidPlan ? "" : "data-blur"}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {!isPaidPlan ? <SQPremiumLockHeader /> : game.closing_line}
                                    </td>
                                    {/* closing line value */}
                                    <td
                                      className={isPaidPlan ? "" : "data-blur"}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {!isPaidPlan ? <SQPremiumLockHeader /> : game.closing_line_value}
                                    </td>
                                    {/* side with line value */}
                                    <td
                                      className={isPaidPlan ? "" : "data-blur"}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {!isPaidPlan ? <SQPremiumLockHeader /> : game.value_side}
                                    </td>
                                    {/* points of value */}
                                    {leagueFromUrl !== "nba" && (
                                      <td
                                        className={isPaidPlan ? "" : "data-blur"}
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {!isPaidPlan ? <SQPremiumLockHeader /> : game.value}
                                      </td>
                                    )}
                                    {/* final score */}
                                    <td
                                      className={isPaidPlan ? "" : "data-blur"}
                                      style={{
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      {!isPaidPlan ? <SQPremiumLockHeader /> : game.home_pts - game.away_pts}
                                    </td>
                                    {/* SQ Score */}
                                    {isPremiumPlan && (
                                      <td
                                        className={isPaidPlan ? "" : "data-blur"}
                                        style={{
                                          textAlign: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        {/* {!isPremiumPlan && <TableHeader headers={SQPremiumLock} />}{" "} */}
                                        {isPremiumPlan && (
                                          <Link
                                            href={`/game/${
                                              leagueFromUrl === "college_mens" ? "ncaa" : leagueFromUrl
                                            }/${leagueYear}/${game?.home_team}/${game?.game_link}`}
                                            style={{ color: "#212529" }}
                                            target={"_blank"}
                                          >
                                            {/* {isPremiumPlan ? Math.round(game.home_sq_pts) : 88} -
                                            {isPremiumPlan ? Math.round(game.away_sq_pts) : 77} */}
                                            {Math.round(game.home_sq_pts)} - {Math.round(game.away_sq_pts)}
                                          </Link>
                                        )}
                                      </td>
                                    )}
                                    {/* Play */}
                                    {leagueFromUrl !== "nba" && (
                                      <td
                                        className={isPaidPlan ? "" : "data-blur"}
                                        style={{
                                          textAlign: "center",
                                          height: "69px",
                                        }}
                                      >
                                        {!isPaidPlan ? (
                                          <SQPremiumLockHeader />
                                        ) : (
                                          !!game.play && (
                                            <button
                                              className="btn-secondary btn-md playColumnBtn"
                                              style={
                                                game.result > 0
                                                  ? { backgroundColor: "#50841B" }
                                                  : game.result < 0
                                                  ? { backgroundColor: "#C72C2C" }
                                                  : { backgroundColor: "#0f131b" }
                                              }
                                            >
                                              {!isSpread && game.value_side === "Over" && "O"}
                                              {!isSpread && game.value_side === "Under" && "U"}
                                              {game.value_side === game.home_team
                                                ? game.line > 0
                                                  ? "+"
                                                  : ""
                                                : game.line * -1 > 0
                                                ? "+"
                                                : ""}
                                              {game.value_side === game.home_team ? game.line : game.line * -1}
                                            </button>
                                          )
                                        )}
                                      </td>
                                    )}
                                  </tr>
                                );
                              }
                            })}
                          </tbody>
                        </table>
                        {tableLoaded && filteredTeamData?.length === 0 && (
                          <div style={{ width: "100%", display: "flex", "justify-content": "center" }}>
                            <h3 style={{ margin: "0 auto" }}>
                              There are no upcoming{" "}
                              {leagueFromUrl.toLowerCase() === "nba"
                                ? "NBA"
                                : leagueFromUrl.toLowerCase() === "wnba"
                                ? "WNBA"
                                : "College Mens"}{" "}
                              Plays available.{" "}
                            </h3>
                          </div>
                        )}
                      </div>
                    </ScrollableTable>
                  </>
                )}
                {!tableLoaded && (isStandardPlan || isPremiumPlan) && domLoaded && (
                  <TableSkeleton
                    tableHeader={miscTableHeader}
                    tableRowsCount={30}
                    className="table-space"
                    tableHeaderHeight="90px"
                  />
                )}
              </div>
            </section>
            <WinningMetrics targetPage={"Results"} />
          </div>
        </main>
      </MainLayout>
    </>
  );
};

export default ModelResults;

export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  return { props: { user } };
});
